import moment from 'moment';
import { postV2, get } from '@/tools/http';

export default {
    namespaced: true,
    state: {
        errorMessage: null,
        nextCodeRequestAt: null,
        newConfirmationAvaliableAt: null,
        nextSubmitAt: null,
        currentValue: null,
        confirmedValue: null,
        isCodeBlockShown: null,
    },
    mutations: {
        setNextCodeRequestAt: (state, v) => state.nextCodeRequestAt = v,
        setNewConfirmationAvaliableAt: (state, v) => state.newConfirmationAvaliableAt = v,
        setNextSubmitAt: (state, v) => state.nextSubmitAt = v,
        setErrorMessage: (state, v) => state.errorMessage = v,
        setCurrentValue: (state, v) => state.currentValue = v,
        setConfirmedValue: (state, v) => state.confirmedValue = v,
        setIsCodeBlockShown: (state, v) => state.isCodeBlockShown = v,
    },
    actions: {
        loadConfirmation: async (ctx) => {
            const res = await get('profile', 'email/confirmation');

            if (!res) {
                return;
            }

            ctx.commit('setErrorMessage', null);
            ctx.commit('setCurrentValue', res.current ? res.current.value : null);
            ctx.commit('setIsCodeBlockShown', res.current ? true : false);
            ctx.commit('setNewConfirmationAvaliableAt', res.current && res.current.newConfirmationAvaliableAt ? moment(res.current.newConfirmationAvaliableAt) : null);
            ctx.commit('setNextCodeRequestAt', res.current && res.current.nextCodeRequestAt ? moment(res.current.nextCodeRequestAt) : null);
            ctx.commit('setNextSubmitAt', res.current && res.current.nextSubmitAt ? moment(res.current.nextSubmitAt) : null);
        },
        requestNewCode: async (ctx, value) => {
            try {
                const res = await postV2('profile', 'email/confirmation/send', { value }, true, { full: false, nullOnError: false });
                ctx.commit('setErrorMessage', res.errorMessage);

                if (!res.current) {
                    return;
                }

                ctx.commit('setNextCodeRequestAt', res.current.nextCodeRequestAt ? moment(res.current.nextCodeRequestAt) : null);
                ctx.commit('setNewConfirmationAvaliableAt', res.current.newConfirmationAvaliableAt ? moment(res.current.newConfirmationAvaliableAt) : null);

                if (!ctx.state.currentValue && !res.current.sendAccepted) {
                    return;
                }

                ctx.commit('setCurrentValue', res.current.value);
                ctx.commit('setIsCodeBlockShown', true);
                ctx.commit('setNextSubmitAt', res.current.nextSubmitAt ? moment(res.current.nextSubmitAt) : null);
            } catch(res) {
                ctx.commit('setErrorMessage', res.errors[0]);
            }
        },
        applyConfirmationCode: async (ctx, code) => {
            if (!ctx.state.currentValue) return;

            try {
                const res = await postV2('profile', 'email/confirmation/confirm', {
                    value: ctx.state.currentValue,
                    code,
                }, true, { full: false, nullOnError: false });
                ctx.commit('setErrorMessage', res.errorMessage);

                if (!res.current) {
                    return;
                }

                if (res.current.isConfirmed) {
                    ctx.commit('setConfirmedValue', res.current.value);
                    ctx.commit('setCurrentValue', res.current.value);
                    ctx.commit('setNextCodeRequestAt', null);
                    ctx.commit('setNextSubmitAt', null);
                    ctx.commit('setIsCodeBlockShown', false);
                } else {
                    if (res.current.nextSubmitAt) {
                        ctx.commit('setErrorMessage', 'Превышено число попыток ввода');
                    } else {
                        ctx.commit('setErrorMessage', 'Неверный код! Повторите попытку ввода');
                    }
                    ctx.commit('setCurrentValue', res.current.value);
                    ctx.commit('setIsCodeBlockShown', true);
                    ctx.commit('setNextCodeRequestAt', res.current.nextCodeRequestAt ? moment(res.current.nextCodeRequestAt) : null);
                    ctx.commit('setNextSubmitAt', res.current.nextSubmitAt ? moment(res.current.nextSubmitAt) : null);
                }
            } catch(res) {
                ctx.commit('setErrorMessage', res.errors[0]);
            }
        },
        setConfirmedValue: async (ctx, value) => {
            ctx.commit('setConfirmedValue', value);
            ctx.commit('setIsCodeBlockShown', false);
        },
        cancelConfirmation: (ctx) => {
            ctx.commit('setIsCodeBlockShown', false);
            ctx.commit('setErrorMessage', null);
        },
        resetErrorMessage: (ctx) => {
            ctx.commit('setErrorMessage', null);
        },
    },
    getters: {
        checkIsConfirmed: state => (value) => {
            return state.confirmedValue && state.confirmedValue === value;
        },
    },
};
